import axios from "axios";

const BASE_URL = process.env.PRE_ENROLLMENT_BASE_URL;

const token = process.env.PRE_ENROLLMENT_UNIVERSAL_ACCESS_TOKEN;
// Axios instance with Authorization header
const axiosInstance = axios.create({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const sentOtpAction = async (data: any): Promise<any> => {
  try {
    const response = await axios.post(`${BASE_URL}auth/apply/register`, data);
    return response.data;
  } catch (error) {
    console.error(`Error in sent OTP`, error);
    throw error;
  }
};

export const otpVerifyAction = async (data: any): Promise<any> => {
  try {
    const response = await axios.post(`${BASE_URL}auth/apply/verify-otp`, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      throw new Error("Wrong OTP. Please try again.");
    }
    console.error(`Error in sent OTP`, error);
    throw error;
  }
};

export const fetchProgramDetails = async (
  programCode: string
): Promise<any> => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}pre-enrolment/student/byProgramCode/${programCode}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching program details`, error);
    throw error;
  }
};

export const submitPaymentDetails = async (data: any): Promise<any> => {
  const crmCountryCode = data?.phone?.startsWith("+234")
    ? "NIGERIA"
    : data.phone.startsWith("+254")
    ? "KENYA"
    : data.phone.startsWith("+27")
    ? "SOUTH AFRICA"
    : data.phone.startsWith("+256")
    ? "UGANDA"
    : data.phone.startsWith("+255")
    ? "TANZANIA"
    : data.phone.startsWith("+263")
    ? "ZIMBABWE"
    : data.phone.startsWith("+267")
    ? "BOTSWANA"
    : data.phone.startsWith("+211")
    ? "SOUTH SUDAN"
    : data.phone.startsWith("+260")
    ? "ZAMBIA"
    : data.phone.startsWith("+264")
    ? "NAMIBIA"
    : null;

  let vineCrmData = null;
  if (crmCountryCode) {
    vineCrmData = {
      domain: "leads",
      type: "update_lead_payment_status",
      name: data?.name,
      mobile: data?.phone,
      highest_qualification: data?.qualification,
      interest: data?.interest,
      email: data?.email,
      reggie_id: data?.newRegId,
      application_fee_status: "Paid",
    };
  }

  const rmsData = {
    regId: data?.newRegId,
    applicationId: String(data?.applicationId),
    paymentStatus: "Paid",
  };
  try {
    const vineCrmApiUrl = process.env.VINE_CRM_API_BASE_URL;
    const rmsApiUrl = `${BASE_URL}pre-enrolment/student/updateApplication`;

    if (!rmsApiUrl) {
      throw new Error(
        "Leads API base URL is not defined in the environment variables"
      );
    }

    await axios.patch(rmsApiUrl, rmsData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (vineCrmData) {
      if (!vineCrmApiUrl) {
        throw new Error(
          "VinCRM API base URL is not defined in the environment variables"
        );
      }
      await axios.post(vineCrmApiUrl, vineCrmData);
    }
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error("Error submitting lead data:", error.message);
    } else {
      console.error("An unexpected error occurred:", error);
    }
    throw error;
  }
};
